<div *ngIf="inspections">
  <div *ngFor="let inspection of inspections">
    <span (click)="selectInspection(inspection)">{{ inspection.name }}</span>
  </div>
</div>
